import { createFileRoute } from "@tanstack/react-router";
import { BEVERLY_HILLS_SHINGLE_STUDY as study } from "@/components/site/case-studies";
import { ProjectStudyPage, projectStudyHead } from "@/components/site/CaseStudy";

export const Route = createFileRoute("/projects/shingle-roof-replacement-beverly-hills-fl")({
  head: () => projectStudyHead(study),
  component: Page,
});

function Page() {
  return <ProjectStudyPage study={study} />;
}
